import React from 'react';
import { Table } from 'antd';

const CurrencyTotalRows = ({ 
    filteredColumns, 
    totalColumns, 
    currencyTotals = [], 
    formatNumber 
}) => {
    // Render total rows for each currency
    const renderCurrencyTotalRows = () => {
        if (!currencyTotals || currencyTotals.length === 0) {
            return null;
        }
        return currencyTotals.map((currencyTotal, index) => (
            <Table.Summary.Row key={`currency-total-${currencyTotal.Currency}`} className="currency-total-summary-row">
                {filteredColumns.map((column, columnIndex) => {
                    // Xác định vị trí các cột mốc
                    const pricingModelsIndex = filteredColumns.findIndex(col => col.dataIndex === 'Pricingmodels');
                    const unitPriceIndex = filteredColumns.findIndex(col => col.dataIndex === 'UnitPrice');

                    // Xác định class dựa trên vị trí cột
                    let cellClassName = 'summary-cell';
                    
                    // Hiển thị "Total {Currency}" cho các cột từ đầu đến Pricing Models
                    if (columnIndex <= pricingModelsIndex) {
                        cellClassName += ' summary-cell-green';
                        // Chỉ hiển thị text "Total {Currency}" ở cột đầu tiên
                        if (columnIndex === 0) {
                            return (
                                <Table.Summary.Cell 
                                    key={`total-${currencyTotal.Currency}-label`} 
                                    index={0}
                                    className={cellClassName}
                                    colSpan={pricingModelsIndex + 1}
                                >
                                    <strong>Total {currencyTotal.Currency}</strong>
                                </Table.Summary.Cell>
                            );
                        }
                        // Bỏ qua các cột đã được gộp
                        if (columnIndex < pricingModelsIndex + 1) {
                            return null;
                        }
                    } else if (columnIndex === unitPriceIndex) {
                        cellClassName += ' summary-cell-normal';
                    } else {
                        cellClassName += ' summary-cell-purple';
                    }

                    // Hiển thị giá trị cho các cột tổng
                    if (totalColumns.includes(column.dataIndex)) {
                        return (
                            <Table.Summary.Cell
                                key={`total-${currencyTotal.Currency}-${column.dataIndex}`}
                                index={column.dataIndex}
                                align="right"
                                className={cellClassName}
                            >
                                {formatNumber(currencyTotal[column.dataIndex])}
                            </Table.Summary.Cell>
                        );
                    }
                    
                    // Các cột không có giá trị tổng
                    return (
                        <Table.Summary.Cell 
                            key={`total-${currencyTotal.Currency}-${column.dataIndex}`} 
                            index={column.dataIndex}
                            className={cellClassName}
                        />
                    );
                })}
            </Table.Summary.Row>
        ));
    };

    return renderCurrencyTotalRows();
};

export default CurrencyTotalRows;